<div class="dfu-wrapper" [class.dfu-wrapper-inline]="renderMode === 'expanded'">
  <div class="dfu-content dfu-content-disabled" *ngIf="renderMode === 'pill'" aria-hidden="true">
    <ng-content></ng-content>
  </div>

  <button
    *ngIf="renderMode === 'pill'"
    type="button"
    class="dfu-pill"
    [class.dfu-pill-inline]="pillMode === 'relative'"
    [class.dfu-pill-open]="isOpen"
    [attr.data-pos]="pillPosition"
    (click)="toggleOpen()"
    [attr.aria-label]="(isOpen ? 'Close' : 'Open') + ' disabled details for ' + title"
  >
    <span class="dfu-pill-text">{{ badgeText }}</span>
  </button>

  <ng-container *ngIf="renderMode === 'expanded'; else pillModeTpl">
    <div class="dfu-card dfu-card-inline">
      <ng-container [ngTemplateOutlet]="cardBodyTpl" [ngTemplateOutletContext]="{ canClose: false }"></ng-container>
    </div>
  </ng-container>

  <ng-template #pillModeTpl>
    <div class="dfu-overlay" *ngIf="isOpen" role="dialog" aria-modal="true">
      <div class="dfu-card" (click)="$event.stopPropagation()">
        <ng-container [ngTemplateOutlet]="cardBodyTpl" [ngTemplateOutletContext]="{ canClose: true }"></ng-container>
      </div>
      <div class="dfu-backdrop" (click)="close()"></div>
    </div>
  </ng-template>

  <ng-template #cardBodyTpl let-canClose="canClose">
    <div class="dfu-card-top">
      <div class="dfu-badge">{{ badgeText }}</div>
      <button *ngIf="canClose" type="button" class="dfu-close" (click)="close()" aria-label="Close">
        ✕
      </button>
    </div>

    <div class="dfu-header">
      <div class="dfu-title" *ngIf="title">{{ title }}</div>
      <div class="dfu-desc">{{ description }}</div>
    </div>

    <a
      *ngIf="learnMoreHref"
      class="dfu-learn"
      [href]="learnMoreHref"
      target="_blank"
      rel="noopener"
    >
      {{ learnMoreLabel }}
    </a>
  </ng-template>
</div>
